import Dashboard from "views/Dashboard.js";
import RoleManagementPanel from "components/RoleManagementPanel";
import "bootstrap-icons/font/bootstrap-icons.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
// import { IconUserFocus2Outline48 } from "@iconify/react";

//import StudentDetails from "views/StudentDetails";
import StudentDetails from "components/student-details";
import AddStudentDetails from "components/add-student-details";
import SmartCounter from "components/smart-counter/SmartCounter";
import CourseSetting from "components/course-setting";
import AreaSelection from "components/area-selection";
import CameraSetting from "components/camera-setting";
import CountVisulizationList from "components/count-visualization-list";
import Eventoccur from "components/event-list/index";
import SummaryDetails from "components/emotions-summary";
import SuspectList from "components/edit-student/suspect/SuspectList";
import Setting from "components/setting";
import AddEmployeeDetails from "components/add-employee-details";
import EditStudentDetails from "components/edit-student";
import UploadFiles from "components/upload-student-files";
import EditStaffDetailsE from "components/add-student-edit/indexeditstaff";
import Editstaff from "components/student-details/editstaff"
import AddUser from "components/add-user";
import DeleteUser from "components/delete-user";
import App from "components/login";
import TargetFaceTables from "components/VisitRecod/TargetFaceTable";
import FaceSearch from "components/VisitRecod/FaceSearch";
import HistorysTa from "components/VisitRecod/History";
import SDashboardT from "components/VisitRecod/SDashboardT";
import VideoCropRecorder from "components/LiveVideo/VideoCropRecorder";
import AddStudentDetailsE from "components/add-student-edit/indexedit";
import StudentStaffpage from "components/student-details/studentStaffpage";
import EditStaffDetails from "components/edit-student/EditStaffDetails"
import Addstaffdetails from "components/add-student-details/addstaff";
import SessionPage from "components/session-page";
import AddSessionDetails from "components/add-session-details";
import EditSessionDetails from "components/edit-session-details";
import AttendenceSession from "components/addAttendesSession";
import StudentRecordDetails from "components/FunnelChart/StudentRecordDetails";
import Persession from "components/FunnelChart/Persession";
import Behavior from "components/behavior-analytics/behavior";
import People from "components/people_count/peopleCount";
import HolidayManagement from "components/HolidayManagement/HolidayManagement";
import StudentTracking from "components/session-det/StudentTracking"; // ✅ NEW IMPORT
import LeaveManagement from "components/LeaveManagement/LeaveManagement"; // Ensure you create this component file
import AddSuspect from "components/student-details/suspect/AddSuspect";
import EditSuspect from "components/student-details/suspect/EditSuspect";
import HelpCenter from "components/helpuser/help-user"
import ShiftManagement from "components/ShiftManagement/ShiftManagement";
const dashboardRoutes = [
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: "nc-icon nc-grid-45",
    component: Dashboard,
    layout: "/admin",
  },
  
  {
    path: "/FaceDetails",
    name: "Face Details",
    icon: "nc-icon nc-camera-20",
    component: StudentDetails,
    layout: "/admin",
  },
  {
    path: "/SessionRecords",
    name: " Reports",
    icon: "nc-icon nc-single-copy-04",
    component: AttendenceSession,
    layout: "/admin",
  },
  {
    path: "/leave-management",
    name: "Leave Management",
    icon: "bi bi-calendar-x", // 👈 Calendar icon with an 'x' indicating absence
    component: LeaveManagement,
    layout: "/admin",
  },
  {
    path: "/shift-management",
    name: "Shift Management",
    icon: "bi bi-clock-history", // Standard clock icon for scheduling
    component: ShiftManagement,
    layout: "/admin",
  },

  
  {
    path: "/camerasetting",
    name: "Camera Setting",

    component: CameraSetting,
    layout: "/admin",
  },
  {
    path: "/areaselection",
    name: "Area Selection",
    component: AreaSelection,
    layout: "/admin",
  },
  {
    path: "/settings",
    name: "Settings",
    icon: "nc-icon nc-settings-gear-64",
    component: Setting,
    layout: "/admin",
  },
  {
    path: "/role-management",
    name: "🔐 Role Management",
    icon: "bi bi-app-indicator",
    component: RoleManagementPanel,
    layout: "/admin",
  },
{
    path: "/help-user",
    name: "Help",
    icon: "bi bi-question-circle",
    component: HelpCenter, 
    layout: "/admin",
  },
  {
    path: "/app",
    name: "Sign Out",
    icon: "nc-icon nc-button-power",
    component: App,
    layout: "/admin",
    table: true,
  },
  
  // --- EVERYTHING BELOW THIS LINE REMAINS AS-IS ---
  {
    path: "/eventoccur",
    name: "Events",
    icon: "nc-icon nc-bell-55",
    component: Eventoccur,
    layout: "/admin",
  },
  {
    // path: "/user",
    name: "Hide/Show",
    icon: "nc-icon nc-bullet-list-67",
    component: "",
  },
  {
    path: "/addMember",
    name: "Hide/Show",
    icon: "nc-icon nc-bullet-list-67",
    layout: "/admin",
    component: AddStudentDetails,
  },
  {
    path: "/bra",
    name: "Hide/Show",
    icon: "nc-icon nc-bullet-list-67",
    layout: "/admin",
    component: AddStudentDetailsE,
  },
  {
    path: "/editstaff/:staff_id",
    name: "Hide/Show",
    icon: "nc-icon nc-bullet-list-67",
    layout: "/admin",
    component: EditStaffDetailsE,
  },
  {
    path: "/editmember",
    name: "Hide/Show",
    icon: "nc-icon nc-bullet-list-67",
    layout: "/admin",
    component: EditStudentDetails,
  },
  {
    path: "/uploadfileStudent",
    name: "Hide/Show",
    icon: "nc-icon nc-bullet-list-67",
    layout: "/admin",
    component: UploadFiles,
  },
  {
    path: "/sAddSession",
    name: "Hide/Show",
    icon: "nc-icon nc-bullet-list-67",
    layout: "/admin",
    component: AddSessionDetails,
  },
  {
    path: "/editSession",
    name: "Hide/Show",
    icon: "nc-icon nc-bullet-list-67",
    layout: "/admin",
    component: EditSessionDetails,
  },
  {
    path: "/add_user",
    name: "Hide/Show",
    icon: "nc-icon nc-bullet-list-67",
    layout: "/admin",
    component: AddUser,
  },
  {
    path: "/delete_user",
    name: "Hide/Show",
    icon: "nc-icon nc-bullet-list-67",
    layout: "/admin",
    component: DeleteUser,
  },
  {
    path: "/estudentStaffpage",
    name: "Hide/Show",
    icon: "nc-icon nc-bullet-list-67",
    layout: "/admin",
    component: StudentStaffpage,
  },
  {
    path: "/editstaff",
    name: "Hide/Show",
    icon: "nc-icon nc-bullet-list-67",
    layout: "/admin",
    component: EditStaffDetails,  // ✅ Use the new staff component
  },
  {
    path: "/addstaff",
    name: "Hide/Show",
    icon: "nc-icon nc-bullet-list-67",
    layout: "/admin",
    component: Addstaffdetails,
  },
  {
    path: "/studentRecordDetails",
    name: "Hide/Show",
    icon: "nc-icon nc-bullet-list-67",
    layout: "/admin",
    component: StudentRecordDetails,
  },
  {
    path: "/persession",
    name: "Hide/Show",
    icon: "nc-icon nc-bullet-list-67",
    layout: "/admin",
    component: Persession,
  },
  {
    path: "/student-tracking",
    name: "Hide/Show",
    icon: "nc-icon nc-bullet-list-67",
    layout: "/admin",
    component: StudentTracking,
  },
  {
    path: "/addSuspect",
    name: "Hide/Show",
    icon: "nc-icon nc-bullet-list-67",
    layout: "/admin",
    component: AddSuspect,
  },

  
  // 👇 ADD THESE TWO ROUTES AT THE BOTTOM 👇

{
    path: "/suspect-list",
    name: "Suspects Directory", 
    icon: "nc-icon nc-single-02", 
    layout: "/admin",
    component: SuspectList,
  },
  {
    path: "/editSuspect/:id",
    name: "Hide/Show", 
    icon: "nc-icon nc-bullet-list-67",
    layout: "/admin",
    component: EditSuspect, // 👈 Make sure this says EditSuspect, NOT SuspectList!
  }
];


export default dashboardRoutes;
